import axios from 'axios';
import type { NotifySettings } from '@bb/domain/dist/types';

const coopDenyTimeChange = async (
  appointmentId: string,
  options: {
    notify: NotifySettings;
    isPending: boolean;
  },
) => {
  await axios.post(`/appointments/send/${appointmentId}/deny_coop`, {
    ...options,
  });
};

export default coopDenyTimeChange;
